// Data for the mobile demo pages
export const mobileData = {
  program: {
    duration_weeks: 12,
    days_per_week: 5,
    split: "PPL ×2",
    notes:
      "Novice 12-week Push/Pull/Legs x2, 5 days per week. 2 compound lifts + 2 isolation movements per day (novice level). Progression via adding weight or reps within the 8–12 (or 6–10 for some heavy lifts) range. Push days finish with a triceps isolation. Legs days keep one squatting movement and avoid rowing movements.",
    experience_level: "novice",
    training_days: [
      {
        name: "Push Day 1",
        focus: "Chest/Shoulders/Triceps",
        movements: [
          {
            name: "Barbell Bench Press",
            pattern_classification: {
              is_compound: true,
              movement_plane: "horizontal",
              pattern: "push",
              primary_muscle_group: "Chest",
            },
            sets: 3,
            reps: "8-12",
            cue: "Tight core, drive through feet, control bar path.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Primary horizontal press; builds chest strength.",
          },
          {
            name: "Overhead Press",
            pattern_classification: {
              is_compound: true,
              movement_plane: "vertical",
              pattern: "push",
              primary_muscle_group: "Shoulders",
            },
            sets: 3,
            reps: "8-12",
            cue: "Brace core, press overhead with control.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Primary vertical press; targets shoulders.",
          },
          {
            name: "Cable Lateral Raise",
            pattern_classification: {
              is_compound: false,
              movement_plane: "frontal",
              pattern: "pull",
              primary_muscle_group: "Shoulders",
            },
            sets: 3,
            reps: "12-15",
            cue: "Keep slight elbow bend; lift to shoulder height.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Shoulder isolation for lateral delts.",
          },
          {
            name: "Overhead Cable Extension",
            pattern_classification: {
              is_compound: false,
              movement_plane: "sagittal",
              pattern: "push",
              primary_muscle_group: "Triceps",
            },
            sets: 3,
            reps: "12-15",
            cue: "Elbows stable; extend fully.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Ends with a triceps isolation per constraint.",
          },
        ],
        reasoning:
          "Push Day 1 emphasizes horizontal and vertical presses, finishing with a triceps isolation.",
      },
      {
        name: "Push Day 2",
        focus: "Chest/Shoulders/Triceps",
        movements: [
          {
            name: "Dips (chest-lean)",
            pattern_classification: {
              is_compound: true,
              movement_plane: "vertical",
              pattern: "push",
              primary_muscle_group: "Chest/Triceps",
            },
            sets: 3,
            reps: "8-12",
            cue: "Lean slightly forward to bias chest.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Chest emphasis with a compound movement.",
          },
          {
            name: "Incline Dumbbell Press",
            pattern_classification: {
              is_compound: true,
              movement_plane: "horizontal",
              pattern: "push",
              primary_muscle_group: "Chest",
            },
            sets: 3,
            reps: "8-12",
            cue: "Full ROM; press to full lockout.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Upper chest and overall pressing strength.",
          },
          {
            name: "Face Pull",
            pattern_classification: {
              is_compound: false,
              movement_plane: "transverse",
              pattern: "pull",
              primary_muscle_group: "Posterior Delts",
            },
            sets: 3,
            reps: "12-15",
            cue: "Pull to brow level; squeeze scapula.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning:
              "Posterior chain health and scapular control.",
          },
          {
            name: "Incline Skull Crusher",
            pattern_classification: {
              is_compound: false,
              movement_plane: "sagittal",
              pattern: "push",
              primary_muscle_group: "Triceps",
            },
            sets: 3,
            reps: "10-15",
            cue: "Elbows steady; extend elbows fully.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Triceps isolation to finish the push session.",
          },
        ],
        reasoning: "Push Day 2 adds variation and ends with a triceps isolation.",
      },
      {
        name: "Pull Day 1",
        focus: "Back/Biceps",
        movements: [
          {
            name: "Conventional Deadlift",
            pattern_classification: {
              is_compound: true,
              movement_plane: "sagittal",
              pattern: "pull",
              primary_muscle_group: "Posterior chain",
            },
            sets: 3,
            reps: "5",
            cue: "Keep spine neutral; move from hips.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Main hip hinge for posterior chain.",
          },
          {
            name: "Barbell Row",
            pattern_classification: {
              is_compound: true,
              movement_plane: "horizontal",
              pattern: "pull",
              primary_muscle_group: "Back",
            },
            sets: 3,
            reps: "8-12",
            cue: "Bar close to torso; squeeze shoulder blades.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Horizontal pull to develop back thickness.",
          },
          {
            name: "Face Pull",
            pattern_classification: {
              is_compound: false,
              movement_plane: "transverse",
              pattern: "pull",
              primary_muscle_group: "Rear Delts",
            },
            sets: 3,
            reps: "12-15",
            cue: "Pull to face; squeeze rear delts.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Postural and rear-delt balance.",
          },
          {
            name: "Reverse Curl",
            pattern_classification: {
              is_compound: false,
              movement_plane: "sagittal",
              pattern: "pull",
              primary_muscle_group: "Forearms",
            },
            sets: 3,
            reps: "12-15",
            cue: "Full contraction; controlled tempo.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Forearm isolation to finish.",
          },
        ],
        reasoning:
          "Pull Day 1 pairs a deadlift with a back row and adds rear-delt/forearm work.",
      },
      {
        name: "Pull Day 2",
        focus: "Back/Biceps",
        movements: [
          {
            name: "Weighted Pull-Up/Chin-Up",
            pattern_classification: {
              is_compound: true,
              movement_plane: "vertical",
              pattern: "pull",
              primary_muscle_group: "Lats/Back",
            },
            sets: 3,
            reps: "6-10",
            cue: "Full ROM; control eccentric.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Vertical pulling for lat development.",
          },
          {
            name: "Lat Pulldown",
            pattern_classification: {
              is_compound: true,
              movement_plane: "vertical",
              pattern: "pull",
              primary_muscle_group: "Lats",
            },
            sets: 3,
            reps: "8-12",
            cue: "Squeeze at bottom; avoid swinging.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Alternative lat-focused pull.",
          },
          {
            name: "Incline Dumbbell Curl",
            pattern_classification: {
              is_compound: false,
              movement_plane: "sagittal",
              pattern: "pull",
              primary_muscle_group: "Biceps",
            },
            sets: 3,
            reps: "10-15",
            cue: "Full range; peak contraction.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Biceps isolation with varied angle.",
          },
          {
            name: "Spiral Curl",
            pattern_classification: {
              is_compound: false,
              movement_plane: "sagittal",
              pattern: "pull",
              primary_muscle_group: "Biceps",
            },
            sets: 3,
            reps: "10-15",
            cue: "Controlled tempo; avoid momentum.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Additional biceps isolation.",
          },
        ],
        reasoning:
          "Pull Day 2 emphasizes lats and biceps with varied curl angles.",
      },
      {
        name: "Leg Day 1",
        focus: "Quads/Hamstrings/Glutes",
        movements: [
          {
            name: "High-Bar Back Squat",
            pattern_classification: {
              is_compound: true,
              movement_plane: "vertical",
              pattern: "squat_lunge",
              primary_muscle_group: "Quads",
            },
            sets: 3,
            reps: "6-10",
            cue: "Chest up; push through heels.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Primary squatting pattern.",
          },
          {
            name: "Romanian Deadlift",
            pattern_classification: {
              is_compound: true,
              movement_plane: "sagittal",
              pattern: "hinge",
              primary_muscle_group: "Hamstrings",
            },
            sets: 3,
            reps: "8-12",
            cue: "Hinge at hips; slow eccentric.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Hip hinge for hamstrings.",
          },
          {
            name: "Glute-Ham Raise/Nordic Curl",
            pattern_classification: {
              is_compound: false,
              movement_plane: "sagittal",
              pattern: "hinge",
              primary_muscle_group: "Glutes/Hamstrings",
            },
            sets: 3,
            reps: "6-10",
            cue: "Control descent; full contraction.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Glute/hamstring isolation.",
          },
          {
            name: "45° Back Extension",
            pattern_classification: {
              is_compound: false,
              movement_plane: "sagittal",
              pattern: "core_anti",
              primary_muscle_group: "Lower back",
            },
            sets: 3,
            reps: "12-15",
            cue: "Engage core; avoid hyperextension.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Lower back/core stability.",
          },
        ],
        reasoning:
          "Leg Day 1 emphasizes squatting with a posterior chain emphasis and back extension for core.",
      },
      {
        name: "Leg Day 2",
        focus: "Quads/Glutes",
        movements: [
          {
            name: "Front Squat",
            pattern_classification: {
              is_compound: true,
              movement_plane: "vertical",
              pattern: "squat_lunge",
              primary_muscle_group: "Quads",
            },
            sets: 3,
            reps: "6-10",
            cue: "Upright torso; elbows high.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Front-loaded quad emphasis.",
          },
          {
            name: "Leg Press",
            pattern_classification: {
              is_compound: true,
              movement_plane: "vertical",
              pattern: "squat_lunge",
              primary_muscle_group: "Quads/Glutes",
            },
            sets: 3,
            reps: "8-12",
            cue: "Full ROM; control the load.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning:
              "Additional quad/glute work without a barbell squat.",
          },
          {
            name: "Wrist Roller",
            pattern_classification: {
              is_compound: false,
              movement_plane: "sagittal",
              pattern: "core_anti",
              primary_muscle_group: "Forearms",
            },
            sets: 3,
            reps: "60s",
            cue: "Roll slowly; maintain grip.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Forearm work to balance grip strength.",
          },
          {
            name: "Glute-Ham Raise/Nordic Curl",
            pattern_classification: {
              is_compound: false,
              movement_plane: "sagittal",
              pattern: "hinge",
              primary_muscle_group: "Glutes/Hamstrings",
            },
            sets: 3,
            reps: "8-12",
            cue: "Controlled descent; full contraction.",
            is_substitution: false,
            substitution_of: "",
            substitution_reason: "none",
            substitution_note: "",
            reasoning: "Hamstrings and glutes isolation.",
          },
        ],
        reasoning:
          "Leg Day 2 adds front-quadricep emphasis with a secondary hinge movement and forearm work.",
      },
    ],
    reasoning:
      "This 12-week plan follows a PPL ×2 framework over 5 days per week with two sessions per muscle group weekly, balancing push/pull/legs with appropriate isolation work and progression cues.",
  },
  progress_pics: {
    frequency_weeks: 4,
    poses: [
      {
        view: "Front",
        cue: "Neutral pose to assess chest/abs/quad development",
        reasoning: "Front view for upper body symmetry",
      },
      {
        view: "Side",
        cue: "Side pose to assess posture and midsection",
        reasoning: "Profile assessment for torso alignment",
      },
      {
        view: "Back",
        cue: "Back pose to assess posture and muscle development",
        reasoning: "Posterior chain visibility",
      },
    ],
    reasoning: "Optional progress photos to track changes over cycles.",
  },
  macro_plan: {
    goal: "Bulk",
    calories_per_day: 2900,
    protein_g: 120,
    carbs_g: 420,
    fat_g: 70,
    activity_level: "light",
    tracking_options: [
      "Upload food photos for AI calorie estimation",
      "Enter food in text for precise macro tracking",
    ],
    notes:
      "Adjust calories by +/- 250 kcal every 2-3 weeks based on progress.",
    source_inputs: {
      sex: "male",
      age: 24,
      height_cm: 165,
      weight_kg: 61,
      bodyfat_pct: 0,
      uses_bodyfat_for_bmr: false,
    },
    calc_config: {
      algorithm_version: "1.0.0",
      bmr_equation: "katch_if_bf_else_mifflin",
      activity_factor_table: "compendium_v1_fixed",
      goal_adjustments: {
        maintain: 0,
        cut: -0.15,
        aggressive_cut: -0.22,
        lean_bulk: 0.08,
        bulk: 0.08,
      },
      protein_rule: "2.0_g_per_kg_BW_or_1.8_g_per_kg_LBM_if_BF>=30",
      fat_rule: { cut: 0.6, maintain: 0.7, lean_bulk: 0.8, bulk: 0.8 },
      carb_rule: "remainder_with_floor_max(100g, 1g_per_kg_BW)",
      rounding: { protein_carbs_to_nearest_g: 5, fat_to_nearest_g: 2 },
      goal_weekly_weight_change_kg: {
        maintain: 0,
        cut: -0.5,
        aggressive_cut: -1,
        lean_bulk: 0.5,
        bulk: 1,
      },
      energy_closure: "adjust_carbs_last",
      include_tef: false,
      include_exercise_calories: true,
    },
  },
};

export type MobileData = typeof mobileData;

